<template>
  <div class="container lnb d_container">
    <div class="contents_wrap no_height">
      <div class="contents list-container">
        <div class="title">{{ this.$route.meta.title }}</div>
        <div class="write_tab mb20">
          <div class="write_tab_content tab_member_detail" @click="movePage(`/item/utility/${utilKey}/detail/${userKey}`)">
            기본정보
          </div>
          <div class="write_tab_content tab_member_detail" @click="movePage(`/item/utility/${utilKey}/detail/${userKey}/use`)">
            사용현황
          </div>
          <div class="write_tab_content tab_member_detail active">
            거래내역
          </div>
        </div>
        <utility-transaction-list-component :utility-type="'utilityTransaction'" :utilKey="utilKey" :userKey="userKey"></utility-transaction-list-component>
      </div>
    </div>
  </div>
</template>
<script>

import UtilityTransactionListComponent from "@/components/utility/UtilityTransactionListComponent";

export default {
  name: "UtilityTransaction",
  mixins: [],
  components: {UtilityTransactionListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      utilKey: Number(this.$route.params.idx),
      userKey: Number(this.$route.params.uu_idx),
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    movePage(url){
      this.$router.push(url);
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
